module.exports = __webpack_public_path__ + "img/card_teaching_record.702018e4.png";